import { IIconProps } from '../../types/IconProps.interface'

export const IconWhatsapp = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 18 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M13.8434 12.356C13.6325 12.9529 12.7943 13.4467 12.1258 13.5911C11.6681 13.6883 11.0714 13.7651 9.06062 12.9319C6.80225 11.9962 3.66625 8.66335 3.66625 6.44543C3.66625 5.31634 4.31725 4.00159 5.45563 4.00159C6.00338 4.00159 6.12413 4.01227 6.30438 4.44464C6.51525 4.95405 7.02975 6.20911 7.091 6.33777C7.34388 6.86555 6.83374 7.17452 6.46362 7.63403C6.34549 7.77232 6.21163 7.92188 6.36125 8.1792C6.51 8.43128 7.0245 9.2698 7.7805 9.94287C8.757 10.8129 9.54887 11.0906 9.83237 11.2088C10.0432 11.2963 10.2953 11.2759 10.4493 11.1114C10.6444 10.9005 10.8867 10.5505 11.1335 10.2056C11.3076 9.9588 11.529 9.92798 11.7609 10.0155C11.9175 10.0698 13.9081 10.9942 13.9921 11.1422C14.0542 11.2498 14.0543 11.759 13.8434 12.356ZM8.75175 7.65102e-07L8.74737 7.64719e-07C3.92349 3.43003e-07 -3.43107e-07 3.92468 -7.64949e-07 8.75C-9.32218e-07 10.6633 0.61688 12.4384 1.666 13.8782L0.575753 17.1296L3.93838 16.0551C5.32175 16.9706 6.97287 17.5 8.75175 17.5C13.5756 17.5 17.5 13.5753 17.5 8.75C17.5 3.92468 13.5756 1.18682e-06 8.75175 7.65102e-07Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  )
}
